import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { UserContext } from "context/userProvider";
import {
  Accordion,
  Breadcrumb,
  Button,
  Divider,
  Form,
  Header,
  Icon,
  Segment,
  Table,
} from "semantic-ui-react";
import LetterLoading from "components/loading/letterLoading";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/customers/customerDetail.scss";
import Swal from "sweetalert2";

export default function CustomerDetail() {
  const [isLoading, setIsLoading] = useState(false);
  const [activeDetail, setActiveDetail] = useState(0);
  const [activeImage, setActiveImage] = useState(0);
  const [customerDetail, setCustomerDetail] = useState([]);
  //const [userList, setUpdateUserList] = useState([]);
  const context = useContext(UserContext);
  const { id } = useParams();
  let statusForm = "";

  useEffect(() => {
    setIsLoading(true);
    getCustomersData();
    // setIsLoading(false);
    setTimeout(() => setIsLoading(false), 1000);
  }, []);

  async function getCustomersData() {
    context.getCustomers({ team_id: -1, role: "" });
    if (context.customerList.length > 0) {
      const detail = context.customerList.filter((user) => user.id === id);
      console.log("customerList", detail[0]);
      setCustomerDetail(detail[0]);
      // setUpdateUserList(detail[0]);
      console.log(customerDetail);
      //   await fetchParts(detail[0].partCode);
    }
  }
 
  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    if (titleProps.name === "userDetail") {
      const newIndex = activeDetail === index ? -1 : index;
      setActiveDetail(newIndex);
    } else {
      const newIndex = activeImage === index ? -1 : index;
      setActiveImage(newIndex);
    }
  };

  const onUpdateUser = async () => {
    if (
        customerDetail.id === null ||
        customerDetail.name === null ||
        customerDetail.phone_no === null ||
        customerDetail.addr === null
    )
    return alertDialog("Warning!", "กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน", "warning");

    const data = {
      id: customerDetail.id,
      name: customerDetail.name,
      email: customerDetail.email,
      phone_no: customerDetail.phone_no,
      phone_no_optional: customerDetail.phone_no_optional,
      addr: customerDetail.address,
    };

    const formData = new FormData()
    formData.append("data", JSON.stringify(data));
    statusForm = "update";

    let result = await context.updateUser(data);
    if (result?.result === "success") {
      return alertDialog("สำเร็จ!", "อัพเดทข้อมูลสำเร็จ", "success");
    } else {
      return alertDialog("ผิดพลาด!", "อัพเดทข้อมูลไม่สำเร็จ", "warning");
    }
  };

  const onResetUserPassword = async () => {
    if (
        customerDetail.id === null
    )
    return alertDialog("Warning!", "กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน", "warning");

    const data = {
      id: customerDetail.id,
    };

    const formData = new FormData()
    formData.append("data", JSON.stringify(data));
    statusForm = "update";

    let result = await context.resetUserPassword(data);
    if (result?.result === "success") {
      return alertDialog("สำเร็จ!", "Reset Password สำเร็จ", "success");
    } else {
      return alertDialog("ผิดพลาด!", "Reset Password ไม่สำเร็จ", "warning");
    }
  };

  const onDeleteUser = async () => {
    if (
        customerDetail.id === null
    )
    return alertDialog("Warning!", "กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน", "warning");

    const data = {
      id: customerDetail.id,
    };

    const formData = new FormData()
    formData.append("data", JSON.stringify(data));
    statusForm = "delete";

    let result = await context.deleteUser(data);
    if (result?.result === "success") {
      return alertDialog("สำเร็จ!", "ลบข้อมูลลูกค้าสำเร็จ", "success");
    } else {
      return alertDialog("ผิดพลาด!", "ลบข้อมูลลูกค้าไม่สำเร็จ", "warning");
    }
  };

  const deleteDevice = async (model,type,deviceserial,clpserial) => {
    const data = {
      id: customerDetail.id,
      model: model,
      type: type,
      deviceserial: deviceserial,
      clpserial: clpserial,
    };
    const formData = new FormData()
    formData.append("data", JSON.stringify(data));
    statusForm = "delete";
    // console.log("datadelete", data);
    let result = await context.deleteDevice(data);
    if (result?.result === "success") {  
      return alertDialog("สำเร็จ!", "ลบข้อมูลสำเร็จ", "success");   
    } else {
      return alertDialog("ผิดพลาด!", "ลบข้อมูลไม่สำเร็จ", "warning");
    } 
  };

  const alertDialog = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    }).then((res) => {
      if(res.isConfirmed && icon === "success" && statusForm === "update") {                
        setIsLoading(true);
        setTimeout(() => {
          setIsLoading(false);
          dataDetail(); 
        }, 1000);   
      }

      if(res.isConfirmed && icon === "success" && statusForm === "delete") {
        getCustomersData();
        setIsLoading(true); 
        setTimeout(() => {
          dataDetail();
          setIsLoading(false);                         
          window.location.reload();     
        }, 5000);     
      }        
    });
  };

  const dataDetail = () => {
    return (
      <Segment>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeDetail === 0}
            index={0}
            name="userDetail"
            onClick={handleClick} >
            <Icon name="dropdown" />
            ข้อมูลลูกค้า
          </Accordion.Title>
          <Accordion.Content active={activeDetail === 0}>
            {userRecordDetail()}
          </Accordion.Content>
        </Accordion>
        <div className="customerDetail-content-button">{createButton()}</div>

        <br />
        <Accordion fluid styled>
          <Accordion.Title
            active={activeImage === -1}
            index={0}
            name="image"
            onClick={handleClick} >
            <Icon name="dropdown" />
            ข้อมูลเครื่องจักร
          </Accordion.Title>
          <Accordion.Content active={activeImage === -1}>
            {deviceDetail()}
          </Accordion.Content>
        </Accordion>
      </Segment>
    );
  };

  const userRecordDetail = () => {
    return (
      <div className="user">
        <table>
          <tbody>
            <tr>
              <td>ชื่อบัญชีผู้ใช้งาน</td>
              <td>
                <Form.Input
                  type="text"
                  placeholder="ชื่อบัญชีผู้ใช้งาน"
                  value={customerDetail?.id}
                  readOnly
                />
              </td>
            </tr>

            <tr>
            <td>
              <label>
                ชื่อ-นามสกุล <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="ชื่อ-นามสกุล"
                    value={customerDetail?.name}
                    onChange={(e) =>
                      setCustomerDetail({
                        ...customerDetail,
                        name: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>
      
          <tr>
            <td>
              <label>
               Line ID 
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="Line ID"
                    value={customerDetail?.email}
                    onChange={(e) =>
                      setCustomerDetail({
                        ...customerDetail,
                        email: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>
                 
          <tr>
            <td>
              <label>
               เบอร์โทร <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="เบอร์โทร"
                    value={customerDetail?.phone_no}
                    onChange={(e) =>
                      setCustomerDetail({
                        ...customerDetail,
                        phone_no: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>
   
          <tr>
            <td>
              <label>ที่อยู่</label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <textarea
                    placeholder="ที่อยู่"
                    value={customerDetail?.address}
                    onChange={(e) =>
                      setCustomerDetail({
                        ...customerDetail,
                        address: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
           </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const deviceDetail = () => {
    return (
      <div className="device">
        <Divider horizontal>
          <Header as="h4">
            <Icon name="tag" />
            ประเภทเครื่องจักร
          </Header>
        </Divider>

        <Table celled striped selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>ประเภทเครื่องจักร</Table.HeaderCell>
              <Table.HeaderCell>รุ่นเครื่องจักร</Table.HeaderCell>
              <Table.HeaderCell>หมายเลขเครื่องจักร</Table.HeaderCell>             
              <Table.HeaderCell>ลบข้อมูลเครื่องจักร</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {customerDetail?.deviceTypes?.length > 0 &&
              customerDetail?.deviceTypes.map((device, idx) => (
                <Table.Row key={idx}>
                  <Table.Cell>{device.type}</Table.Cell>
                  <Table.Cell>{device.model}</Table.Cell>
                  <Table.Cell>{device.clpserial}</Table.Cell>                 
                  <Table.Cell><Button color="red" 
                         onClick={() => deleteDevice(device.model, device.type, 
                         device.deviceserial, device.clpserial)}>
                         ลบข้อมูล</Button>
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
        <br />

        <Divider horizontal>
          <Header as="h4">
            <Icon name="tag" />
             รายละเอียดเครื่องจักร
          </Header>
        </Divider>

        <Table celled striped selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>หมายเลขเครื่องจักร</Table.HeaderCell>
              <Table.HeaderCell>หมายเลขอุปกรณ์ IoT</Table.HeaderCell>              
              <Table.HeaderCell>วันที่ซื้อสินค้า</Table.HeaderCell>
              <Table.HeaderCell>หมายเหตุ</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {customerDetail?.deviceTypes != null &&
              customerDetail?.deviceTypes.map((device, idx) => (
                <Table.Row key={idx}>
                  <Table.Cell>{device.clpserial}</Table.Cell>
                  <Table.Cell>{device.deviceserial}</Table.Cell>                 
                  <Table.Cell>{device.devicebuydate}</Table.Cell>
                  <Table.Cell>{device.description}</Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </div>
    );
  };

  const createButton = () => {
    return (
      <>
        {customerDetail?.is_active === 1 && (
        <Button color="blue" onClick={() => onUpdateUser()}>
          อัพเดทข้อมูลลูกค้า
        </Button>)}

        {context.userDetail?.role === "admin" && customerDetail?.is_active === 1 && (
        <Button color="green" onClick={() => onResetUserPassword()}>
          Reset Password
        </Button>)}

        {context.userDetail?.role === "admin" && customerDetail?.is_active === 1 && (
        <Button color="red" onClick={() => onDeleteUser()}>
          ลบข้อมูลลูกค้า
        </Button>)}

        &emsp;
        {/* {users.userDetail?.role === "manager" && (
          <Button color="green" onClick={() => onUpdateMaintenance("approve")}>
            อนุมัติ
          </Button>
        )} */}
      </>
    );
  };

  const sections = [
    { key: "หน้าแรก", content: "หน้าแรก", link: true, href: "/home" },
    { key: "ประวัติลูกค้า", content: "ประวัติลูกค้า", link: true, href: "/customers-list"},
    { key: `${customerDetail?.id}`, content: `${customerDetail?.id}`, active: true},
  ];

  return (
    <div className="customerDetail">
      <LetterLoading isOpen={isLoading} />
      <Sidebar tabActive="customersRecord" />
      <Navigation />

      <div className="customerDetail-content">
        <div className="customerDetail-content-header">
          <h2>ประวัติลูกค้า : {customerDetail?.id}</h2>

          {customerDetail?.is_active === 0 && (
           <Button color="red" >
            ข้อมูลลูกค้าถูกยกเลิกการใช้งานในระบบแล้ว
          </Button>)}
        </div>
        <hr />
        <Breadcrumb icon="right angle" sections={sections} />
        <div className="customerDetail-content-detail">{dataDetail()}</div>
        {/* <div className="customerDetail-content-button">{createButton()}</div> */}
      </div>
    </div>
  );
}
